import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';
import {ETicketPage} from '../eTicketPage.type';
import TransactionCard from '../TransactionCard/TransactionCard';
import TransactionTop from '../TransactionCard/TransactionTop/TransactionTop';
import EndingContent from '../EndingContent/EndingContent';
import BrandHeader from '../BrandHeader/BrandHeader';
import {buildSubscriptionPages, buildTicketPages} from './eTicketPages.utils';

export function useETicketPages() {
    const data = useSelector((s: RootState) => s.eTicket.data);

    const tickets = data?.tickets ?? [];
    const event = data?.event;
    const order = data?.order;

    // A subscription ticket is identified by ticket.subscription. When the order holds one it takes
    // the place of the cover slide; the transaction and ending slides are shared by both kinds.
    const pages = useMemo((): ETicketPage[] => {
        const subscriptionTickets = tickets.filter(ticket => ticket.subscription);
        const regularTickets = tickets.filter(ticket => !ticket.subscription);

        return [
            ...(subscriptionTickets.length && data
                ? [
                    ...buildSubscriptionPages(subscriptionTickets, data),
                    ...buildTicketPages({tickets: regularTickets, event, order, withCover: false})
                ]
                : buildTicketPages({tickets, event, order})),
            {key: 'transaction', withLink: true, TopComp: TransactionTop, Comp: TransactionCard},
            {key: 'ending', withLink: false, hasFooter: false, TopComp: BrandHeader, Comp: EndingContent}
        ];
    }, [data]);

    return {pages};
}
